const BASE_CLIENT_NAMESPACE = 'core.http';
const DEFAULT_HTTP_TIMEOUT = 10_000;

export { BASE_CLIENT_NAMESPACE, DEFAULT_HTTP_TIMEOUT };
//# sourceMappingURL=const.js.map
